import CustomTextBox from "app/components/atoms/customTextBox";

export const getEmployeeProfileRequestUiSchema = {
  "ui:title": "",
  name: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  email: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  employer: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
  reasonForContacting: {
    "ui:widget": (props) => {
      return <CustomTextBox getProps={props} />;
    },
  },
};

